import { RadialGauge } from '@progress/kendo-react-gauges';
import { useLocalization } from '@progress/kendo-react-intl';
import axios from 'axios';
import { useEffect, useState } from 'react';


export const ServerStatus = () => {

    const localizationService = useLocalization();
    
    const gaugeStyles = {
        display: 'block'
    };
    
    const [ cpuUsage, setCpuUsage ] = useState(0);
    const [ ramUsage, setRamUsage ] = useState(0);
    const [ cpuStatus, setCpuStatus ] = useState('low');
    const [ ramStatus, setRamStatus ] = useState('low');

    const [ongoingMissions, setOngoingMissions] = useState(0);
    const [activeVehicles, setActiveVehicles] = useState(0);

    const pointerCPU = { value: cpuUsage };
    const pointerRAM = { value: ramUsage };

    useEffect(() => {

        const getDiagnosticSynchro = async () => {
            axios.get("http://54.217.164.88:5001/api/diagnostic/synchro")
            .then((res: any) => {
                const data = res?.data

                let ongoingMissions = data.ongoingMissions
                let activeVehicles = data.activeVehicles

                setOngoingMissions(ongoingMissions)
                setActiveVehicles(activeVehicles)
                
                let currCpuUsage: number = 22
                let currRamUsage: number = 55
                setCpuUsage(22)
                setRamUsage(55)

                let cpuStatus:string = 'low'
                let ramStatus:string = 'low'
                if(currCpuUsage < 30){
                    cpuStatus = 'low'
                }else if(currCpuUsage < 60){
                    cpuStatus = 'medium'
                }else{
                    cpuStatus = 'high'
                }
                if(currRamUsage < 30){
                    ramStatus = 'low'
                }else if(currRamUsage < 60){
                    ramStatus = 'medium'
                }else{
                    ramStatus = 'high'
                }
                setCpuStatus(cpuStatus)
                setRamStatus(ramStatus)

            })
            .catch((error) => {
                console.log(error);
            });
        }
        const interval = setInterval(() => {
            getDiagnosticSynchro()
        }, 10000);
        return () => clearInterval(interval);
    }, []);

return (
    <div className="">
        <div className="usage-status">
            <div className="usage-wrapper">
                <div className={`usage-title level-${cpuStatus}`}>
                    {cpuStatus}
                </div>
                <div className="usage-description" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                    {localizationService.toLanguageString('synchro.cpu_usage', 'NOT_FOUND')}: {cpuUsage}%
                </div>
            </div>
            <div className="usage-image">
                <RadialGauge style={gaugeStyles} pointer={pointerCPU} />
            </div>
        </div>
        <div className="usage-status">
            <div className="usage-wrapper">
                <div className={`usage-title level-${ramStatus}`}>
                    {ramStatus}
                </div>
                <div className="usage-description" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                {localizationService.toLanguageString('synchro.ram_usage', 'NOT_FOUND')}: {ramUsage}%
                </div>
            </div>
            <div className="usage-image">
                <RadialGauge style={gaugeStyles} pointer={pointerRAM} />
            </div>
        </div>

        <div className="usage-description" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: '10px', marginLeft: '20px', marginRight: '20px'}}>
            <p style={{fontSize: '13px'}}>{localizationService.toLanguageString('synchro.ongoing_missions', 'NOT_FOUND')}: {ongoingMissions}</p>
            <p style={{fontSize: '13px'}}>{localizationService.toLanguageString('synchro.activeVehicles', 'NOT_FOUND')}: {activeVehicles}</p>
        </div>

    </div>
)
}